// extracted by mini-css-extract-plugin
module.exports = {"single-mobile-menu":"SingleNavMenuMobile_single-mobile-menu__2xZZD","active":"SingleNavMenuMobile_active__lJ9Zw"};